import { computeMemberArrearsMonthsForBanner } from './memberDashboardPersonalStats';

/** Mois d’impayé au-delà desquels l’UI passe en alerte rouge (bandeau, cartes, liste admin). */
export const CONTRIBUTION_ARREARS_CRITICAL_MONTHS = 3;

export function isArrearsCritical(unpaidMonthCount) {
  return Number(unpaidMonthCount) > CONTRIBUTION_ARREARS_CRITICAL_MONTHS;
}

/**
 * Nombre de mois d’impayé affiché : calcul local (historique), sans gonfler via unpaid_months API
 * (souvent compté depuis une date d’org trop ancienne → faux « 23 mois »).
 */
export function harmonizedMemberUnpaidMonthsDisplay(personalStats) {
  if (!personalStats || typeof personalStats !== 'object') return 0;
  return computeMemberArrearsMonthsForBanner(personalStats);
}

const CARD_SEVERE = {
  border: 'border-red-200',
  bg: 'bg-gradient-to-br from-red-50 to-rose-50',
  label: 'text-red-800',
  value: 'text-red-950',
  iconBg: 'bg-red-500',
};

const CARD_WARN = {
  border: 'border-amber-200',
  bg: 'bg-gradient-to-br from-amber-50 to-yellow-50',
  label: 'text-amber-900',
  value: 'text-amber-950',
  iconBg: 'bg-amber-500',
};

/** Style carte « Mois impayés » (jaune ≤ seuil, rouge au-delà). */
export function unpaidMonthsCardClasses(unpaidMonths) {
  return isArrearsCritical(unpaidMonths) ? CARD_SEVERE : CARD_WARN;
}
